import { Key, useState } from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table'
import { CostCenterFormSchema } from '../validators/cost-center-validator'
import { DialogEditCostCenter } from '../modals/modal-edit-cost-center'
import { Pencil, Trash2 } from 'lucide-react'
import { DialogDelete } from '../modals/modal-delete';
import { Endpoints } from '@/remote/endpoints'
import { convertDateDisplayFormat } from '../utils/formatDateDisplay'
import { ScrollArea } from './ui/scroll-area'


type TableCostCenter = {
  data: CostCenterFormSchema[],
  height?: string,
  getRefreshList?: () => void
}

export function TableCostCenter({ data, height, getRefreshList }: TableCostCenter) {

  const [dialogEdit, setDialogEdit] = useState(false)
  const [dialogDelete, setDialogDelete] = useState(false)
  const [dataId, setDataId] = useState(0)


  const openDialogEdit = (id: number) => {
    setDataId(id)
    setDialogEdit(true)
  }

  const closeDialogEdit = () => {
    setDialogEdit(false)
  }


  const openDialogDelete = (id: number) => {
    setDataId(id)
    setDialogDelete(true)
  }

  const closeDialogDelete = () => {
    setDialogDelete(false)
  }


  return (
    <div className={'overflow-y-auto' + height}>
      {dialogEdit && <DialogEditCostCenter updateList={getRefreshList} closeDialog={closeDialogEdit} id={dataId} isOpen={dialogEdit} />}
      {dialogDelete && <DialogDelete updateList={getRefreshList} closeDialog={closeDialogDelete} id={dataId} isOpen={dialogDelete} url={Endpoints.costCenter} label='Centro de Custo' />}
      <ScrollArea className="m-4 h-container-members-list relative">
        <Table className='border-none'>
          <TableHeader className=''>
            <TableRow>
              <TableHead >ID</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Código</TableHead>
              <TableHead>Descrição</TableHead>
              <TableHead>Inclusão</TableHead>
              <TableHead>Alteração</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody className=''>
            {data.map((costCenter: CostCenterFormSchema, position: Key | null | undefined) => (
              <TableRow key={position} className='text-gray-600'>
                <TableCell>{costCenter.id}</TableCell>
                <TableCell>{costCenter.status ? 'Ativo' : 'Desativado'}</TableCell>
                <TableCell>{costCenter.codigo}</TableCell>
                <TableCell>{costCenter.descricao}</TableCell>
                <TableCell>{costCenter.inclusao ? convertDateDisplayFormat(costCenter.inclusao?.split('T')[0]) : 'Sem informação'}</TableCell>
                <TableCell>{costCenter.alteracao ? convertDateDisplayFormat(costCenter.alteracao?.split('T')[0]) : 'Sem Alteração'}</TableCell>
                <TableCell className='flex'>
                  <Pencil
                    onClick={() => openDialogEdit(costCenter?.id || 0)}
                    height={24}
                    width={30}
                    className='text-blue-500 cursor-pointer p-1  hover:text-blue-400' />
                  <Trash2
                    onClick={() => { openDialogDelete(costCenter?.id || 0) }}
                    height={24}
                    width={30}
                    className='text-red-500 cursor-pointer p-1  hover:text-red-400' />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ScrollArea>
    </div>
  )

}